import React from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

/**
 * Compact toggle used in the wizard for boolean flags
 * like `sides_differ`.
 */
export default function ToggleField({ id, label, checked, onCheckedChange, testId, hint }) {
  return (
    <div className="flex items-center justify-between gap-3 border border-[color:var(--border)] bg-[color:var(--surface-2)] px-3 py-1.5 rounded">
      <div className="flex flex-col">
        <Label
          htmlFor={id}
          className="text-xs uppercase tracking-[0.18em] text-[color:var(--text)] font-mono font-medium cursor-pointer"
        >
          {label}
        </Label>
        {hint && <span className="text-[10px] text-[color:var(--text-mute)] mt-1">{hint}</span>}
      </div>
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        data-testid={testId}
        className="data-[state=checked]:bg-[color:var(--brand)]"
      />
    </div>
  );
}
